<template>
  <div class="convention-hall page" style="width: 100%; background: url('/img/home/g.f7e76bcc.png') center top / 100% repeat;">
    <van-nav-bar class="nav-bar" :title="$t('foorter.benefits')" left-arrow @click-left="onClickLeft">
    </van-nav-bar>

    <!-- Section 1: 情趣用品 -->
    <div class="section-title" style="background: linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8));">
      {{ $t('welfare.adult_products') }}
    </div>
    <div class="pblBox">
      <div v-for="(item, index) in adultProducts" :key="'adult-' + index" style="width: calc(50% - 5px);">
        <div class="releaseItem">
          <div class="imgBox">
            <img :src="item.img" />
            <span><i>{{ $t('concubine.high_end') }}</i></span>
          </div>
          <div class="tagBox">{{ item.name }}</div>
          <div class="getBtn" @click="goService()">{{ $t('welfare.get_now') }}</div>
        </div>
      </div>
    </div>
    <div class="methodBox">
      <div>{{ $t('welfare.adult_method') }}</div>
      <div class="methodDesc">{{ $t('welfare.method_desc') }}</div>
    </div>

    <!-- Section 2: 奢侈品 -->
    <div class="section-title" style="background: linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8));">
      {{ $t('welfare.luxury') }}
    </div>
    <div class="pblBox">
      <div v-for="(item, index) in luxuryProducts" :key="'luxury-' + index" style="width: calc(50% - 5px);">
        <div class="releaseItem">
          <div class="imgBox">
            <img :src="item.img" />
            <span><i>{{ $t('concubine.high_end') }}</i></span>
          </div>
          <div class="tagBox">{{ item.name }}</div>
          <div class="getBtn" @click="goService()">{{ $t('welfare.get_now') }}</div>
        </div>
      </div>
    </div>
    <div class="methodBox">
      <div>{{ $t('welfare.luxury_method') }}</div>
      <div class="methodDesc">{{ $t('welfare.method_desc') }}</div>
    </div>

    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      adultProducts: [
        { name: 'Benefit 1', img: '/img/welfare/5dc26b3afc2ca639d42e6839c1453496.jpg' },
        { name: 'Benefit 2', img: '/img/welfare/710553a6a23cde8cc022b06368e52fe4.jpg' },
        { name: 'Benefit 3', img: '/img/welfare/74463f11f004e8989c546820eed6d1fa.jpg' },
        { name: 'Benefit 4', img: '/img/welfare/92391da257d70f47427288f3a3861f55.jpg' },
        { name: 'Benefit 5', img: '/img/welfare/e11e2d2944f805ae0505bbbd7b089126.jpg' },
        { name: 'Benefit 6', img: '/img/welfare/d144d29c9ef395690251de771051f1a1.jpg' },
      ],
      luxuryProducts: [
        { name: 'Benefit 1', img: '/img/welfare/af78e4eb927879507cb8cc58b5e52421.jpg' },
        { name: 'Benefit 2', img: '/img/welfare/104956a7a4c2261c8ce07812e415213a.jpg' },
        { name: 'Benefit 3', img: '/img/welfare/92a872f0014c3b7e2cdb34b0dc294c58.jpg' },
        { name: 'Benefit 4', img: '/img/welfare/31474c1e375ddba642c949b3018b1f91.jpg' },
        { name: 'Benefit 5', img: '/img/welfare/a09ba9b97bdd9612a237ab4bcab51a85.jpg' },
        { name: 'Benefit 6', img: '/img/welfare/813e663c8d5b6ad0f8f94eeb33ae0457.jpg' },
      ]
    };
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    goService() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/ServiceOnline' });
      } else {
        this.$router.push({ path: '/Login' });
      }
    }
  }
};
</script>

<style scoped lang="less">
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.nav-bar {
  background: transparent !important;
}

::v-deep .van-nav-bar__content {
  background: transparent !important;
}

::v-deep .van-nav-bar__title {
  color: #000;
}

.section-title {
  width: 94%;
  margin: 16px auto 0;
  padding: 6px 0;
  text-align: center;
  color: #fff;
  font-size: 4vw;
  font-weight: 600;
  border-radius: 8px;
}

.pblBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 3%;
}

.releaseItem {
  width: 100%;
  margin-bottom: 10px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  padding-bottom: 6px;
}

.releaseItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  height: 45vw;
}

.releaseItem .imgBox img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.releaseItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 16vw;
  height: 16vw;
  top: -8vw;
  right: -8vw;
}

.releaseItem .imgBox span i {
  position: absolute;
  bottom: 1vw;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 3vw;
  white-space: nowrap;
}

.tagBox {
  font-size: 3.5vw;
  margin: 6px 8px 4px;
  color: rgb(102, 102, 102);
  text-align: center;
}

.getBtn {
  margin: 4px 8px;
  padding: 6px 0;
  text-align: center;
  color: #fff;
  font-size: 3.5vw;
  font-weight: 600;
  border-radius: 8px;
  background: linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8));
}

.methodBox {
  width: 94%;
  margin: 10px auto;
  padding: 12px 16px;
  border-radius: 8px;
  box-sizing: border-box;
  background: repeating-linear-gradient(-60deg, rgba(248, 92, 154, 0.9), rgba(246, 74, 142, 0.9), rgba(248, 92, 154, 0.9), rgba(246, 74, 142, 0.9));
  color: #fff;
}

.methodDesc {
  font-size: 3vw;
  margin-top: 4px;
  opacity: 0.9;
}
</style>
